export enum AccountState {
  NO_USER = 'NO_USER',
  EXISTS = 'EXISTS',
  ERROR = 'ERROR',
}

export type AccountStateType = `${AccountState}` | undefined;
